import { Component, ChangeDetectionStrategy } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-footer-component',
  imports: [
    RouterLink
  ],
  templateUrl: './footer-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer-component.scss'
})
export class FooterComponent {

}
